import useObjectsView from "@organisms/ObjectsView/ObjectsView.context"
import ViewBar from "@organisms/ViewBar/ViewBar"

import { ObjectsViewTabsProps } from "./ObjectsViewTabs.types"

export default function ObjectsViewTabs(props: ObjectsViewTabsProps) {
    const { children } = props

    const { activePhase } = useObjectsView()

    return <ViewBar.Tabs activePhase={activePhase}>{children}</ViewBar.Tabs>
}
